import { useRouteError } from "react-router-dom";
import { ErrorFallback } from "./ErrorFallback";

/** Router errorElement — catches render/loader errors and offers to report them. */
export function RouteError() {
  return <ErrorFallback error={useRouteError()} />;
}
